import { InjectionToken } from '@angular/core';

/** Base URL del API (incluye `/api/v1`). Configúrala en `app.config.ts`. */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
